/**
 * Gets the percentage of a value between a min and max value.
 *  - If the value is less than the min value, the percentage will be 0.
 * - If the value is greater than the max value, the percentage will be 100.
 * @param minVal The minimum value.
 * @param maxVal The maximum value.
 * @param currentVal The current value.
 * @returns The percentage of the current value between the min and max values.
 * @throws An error if the min and max values are the same.
 * @example
 * computePercentage(0, 100, 50); // 50
 * computePercentage(0, 100, 0); // 0
 * computePercentage(0, 100, 100); // 100
 * computePercentage(0, 100, 101); // 100
 * computePercentage(0, 100, -1); // 0
 * */

export const computePercentage = (minVal: number, maxVal: number, currentVal: number) => {
  if (maxVal === minVal) {
    throw new Error('maxVal and minVal cannot be the same.');
  }
  const percentage = ((currentVal - minVal) / (maxVal - minVal)) * 100;

  // Ensure the result is within [0, 100] due to potential floating point errors.
  return Math.max(0, Math.min(100, percentage));
};
